import React, { memo, SVGProps } from 'react'

export const BadgeAdmin = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M12.18 4C8.77 4 6 4.91 6 5.99V13.03C6 17.28 12.18 19.18 12.18 19.18C12.18 19.18 18.36 17.28 18.36 13.03V5.99C18.36 4.9 15.59 4 12.18 4ZM14.55 14.48L12.18 13.23L9.81 14.48L10.26 11.84L8.34 9.97L10.99 9.58L12.18 7.18L13.37 9.59L16.02 9.98L14.1 11.85L14.55 14.49V14.48Z"
      fill="currentColor"
    />
  </svg>
))
